import Link from "next/link";
import React from "react";
import {
  CourseBlock,
  CourseContainer,
  CourseDescription,
  CourseText,
  CourseTitle,
} from "./styles";

export const CourseItem = ({ id, title, description, srcImage }) => (
  <Link
    href={`/lectures/${id}`} passHref
    shallow
  >
    <CourseContainer>
      <CourseBlock srcImage={srcImage}>
        {/* <CourseText>
        <CourseTitle>{title}</CourseTitle>
        <CourseDescription>{description}</CourseDescription>
      </CourseText> */}
      </CourseBlock>
    </CourseContainer>
  </Link>
);
